import React, { useState, useEffect, useCallback } from 'react';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import DataTable from 'components/DataTable/DataTable';
import { connect } from 'react-redux';
import { titleCaseFunction } from 'helpers/TitleCaseFunction';
import PropTypes from 'prop-types';
import { redTableCellStyle } from 'components/DataTable/DataTable.styled';
import { parseDate } from '../../../helpers/DateFormatter';
import DateSection from './DateSection/DateSection';
import { updatedTabledefination } from './MOSelection.constants';
import { setDataForTagSelectionMOScreen, sortMO, setAndFilterMoData } from './MOSelection.actions';
import { getSelectedTagsForTagMOScreenData } from '../TagSelectionMOScreen/TagSelectionMOScreen.actions';
import { moSelectionInitialState } from './MOSelection.data';
import _ from 'lodash';
import { getAllTagBiSelectionMOScreenData, getAllTagSelectionMOScreenData } from '../Home/Home.actions';

const MOSelectionPage = (props) => {
  const { moDataAll, triggerSort, initialiseTagSelectionMOScreendata,
    selectedAssetName, selectedBarrierType, tags, loadAllTagSelectionMOScreenData,
    loadSelectedTagsForTagMOScreenData, startDate, finishDate, loadAllTagBiSelectionMOScreenData,
    searchCriteria, isTableLoading, selectedWorkType, filteredMoData, testStatusFilterMo, selectedRowTags, searchAndFilterMoDataAll, tagsLoaded, tagsBiLoaded } = props;
  const [sortAscOrder, setSortAscOrder] = useState(false);
  const barrierTypeForFilter = (selectedBarrierType === 'all' && selectedWorkType.toLowerCase() === 'preventative')
    ? ['p7 sis', 'm6 f&g', 'p6 sri/src', 'p8 sra']
    : [selectedBarrierType];

  const [tableData, setTableData] = useState([]);
  const now = new Date();
  const { redTableCell } = redTableCellStyle();

  useEffect(() => {
    const data = filteredMoData.filter(
      item => barrierTypeForFilter.includes(item.BarrierType.toLowerCase())
        && item.BpSiteName?.toLowerCase() === selectedAssetName
        && new Date(`${item.ScheduleFinishDate}Z`).setHours(0, 0, 0, 0) >= new Date(startDate).setHours(0, 0, 0, 0)
        && new Date(`${item.ScheduleFinishDate}Z`).setHours(0, 0, 0, 0) <= new Date(finishDate).setHours(0, 0, 0, 0));
    const mappedResult = data.map((item) => {
      const result = tags.filter((tag) => tag.HdWorkOrder === item.HdWorkOrder && tag.InDraftState);
      return {
        ...item,
        InDraftState: result.length > 0,
      };
    });
    setTableData(mappedResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredMoData, tags, selectedRowTags, startDate, finishDate]);

  useEffect(() => {
    if (moDataAll && tagsLoaded && tagsBiLoaded && (!_.isEqual(searchCriteria, moSelectionInitialState?.searchCriteria) || (testStatusFilterMo !== moSelectionInitialState?.testStatusFilterMo))) {
      searchAndFilterMoDataAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moDataAll, searchCriteria, testStatusFilterMo, selectedRowTags, tagsLoaded, tagsBiLoaded]);
  useEffect(() => {
    loadAllTagSelectionMOScreenData();
    loadAllTagBiSelectionMOScreenData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sortButtonHandler = (columnName) => {
    triggerSort(columnName, sortAscOrder);
    setSortAscOrder(!sortAscOrder);
  };

  const getParsedTableData = useCallback(() => tableData.map((item) => ({
    ...item,
    IsCellRedClassStartDate: (item.ScheduleStartDate && new Date(item.ScheduleStartDate).setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0)),
    ScheduleStartDate: parseDate(`${item.ScheduleStartDate}Z`),
    ScheduleFinishDate: parseDate(`${item.ScheduleFinishDate}Z`),
    IsCellRedClassFinishDate: (item.ScheduleFinishDate && new Date(`${item.ScheduleFinishDate}Z`).setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0))
      ? redTableCell : null,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })), [tableData]);

  const handleArrowButton = (rowData) => {
    initialiseTagSelectionMOScreendata(rowData);
    loadSelectedTagsForTagMOScreenData(rowData);
  };

  return (
    <SiteWrapper
      headerText={`MO Selection: ${titleCaseFunction(selectedWorkType)}`}
      showTotalCount
      totalCount={tableData.length}
      goBack="home"
      footerNoteMoVisible={getParsedTableData().some(obj => obj.IsCellRedClassStartDate || obj.IsCellRedClassFinishDate)}
      draftNoteVisible={getParsedTableData().some(obj => obj.InDraftState)}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <DateSection />
            <DataTable
              id="MOSelectionDataTable"
              tableDefinition={updatedTabledefination}
              tableData={getParsedTableData()}
              isLoading={isTableLoading}
              sortButtonHandler={sortButtonHandler}
              showArrowButton
              actionButtonHandler={(dataRow) => handleArrowButton(dataRow)}
              height="calc(100vh - 257px)"
            />
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

const mapStateToProps = ({ MOSelection, Home, TagSelectionMOScreen }) => ({
  isTableLoading: MOSelection.tableLoading,
  moDataAll: MOSelection.moDataAll,
  searchCriteria: MOSelection.searchCriteria,
  totalCount: MOSelection.totalCount,
  selectedAssetName: Home.selectedAssetName,
  selectedBarrierType: Home.selectedBarrierType,
  startDate: MOSelection.startDate,
  finishDate: MOSelection.endDate,
  tagsLoaded: Home.tagsLoaded,
  tags: Home.tags,
  tagsBiLoaded: Home.tagsBiLoaded,
  selectedRowTags: TagSelectionMOScreen.selectedRowTags,
  selectedWorkType: Home.selectedWorkType,
  filteredMoData: MOSelection.filteredMoData,
  testStatusFilterMo: MOSelection.testStatusFilterMo
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  searchAndFilterMoDataAll: () => dispatch(setAndFilterMoData()),
  initialiseTagSelectionMOScreendata: (rowData) => dispatch(setDataForTagSelectionMOScreen(rowData)),
  loadSelectedTagsForTagMOScreenData: (rowData) => dispatch(getSelectedTagsForTagMOScreenData(rowData)),
  loadAllTagSelectionMOScreenData: () => dispatch(getAllTagSelectionMOScreenData()),
  loadAllTagBiSelectionMOScreenData: () => dispatch(getAllTagBiSelectionMOScreenData()),
  triggerSort: (colForSorting, sortAscOrder) => dispatch(sortMO(colForSorting, sortAscOrder)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MOSelectionPage);

MOSelectionPage.propTypes = {
  filteredMoData: PropTypes.array,
  finishDate: PropTypes.any,
  initialiseTagSelectionMOScreendata: PropTypes.func,
  isTableLoading: PropTypes.bool,
  loadAllTagBiSelectionMOScreenData: PropTypes.func,
  loadAllTagSelectionMOScreenData: PropTypes.func,
  loadSelectedTagsForTagMOScreenData: PropTypes.func,
  moDataAll: PropTypes.array,
  searchAndFilterMoDataAll: PropTypes.func,
  searchCriteria: PropTypes.object,
  selectedAssetName: PropTypes.string,
  selectedBarrierType: PropTypes.string,
  selectedRowTags: PropTypes.array,
  selectedWorkType: PropTypes.string,
  startDate: PropTypes.any,
  tags: PropTypes.array,
  tagsBiLoaded: PropTypes.bool,
  tagsLoaded: PropTypes.bool,
  testStatusFilterMo: PropTypes.string,
  triggerSort: PropTypes.func
};
